import { useBorrowerPmcName } from '../../../../../../../queries/BorrowerFields/PmcFields';
import { TextBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../../../components/ApplicationQuestionReviewItem';

interface PropertyManagementCompanyNameProps {
    required?: boolean;
    readOnly?: boolean;
    isReview?: boolean;
}

//TODO: handle submitted / validation if need be
export const PropertyManagementCompanyName: React.FC<PropertyManagementCompanyNameProps> = ({
    required = false,
    readOnly = false,
    isReview = false,
}) => {
    const label = 'Company Name';
    const [companyName, set_companyName] = useBorrowerPmcName();
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={companyName}
                />
            ) : (
                <TextBox
                    id='propertyManagementCompanyName'
                    value={companyName}
                    onChange={(value) => set_companyName(value)}
                    label={label}
                    placeholder='The Property Company, LCC'
                    required={required}
                    width='100%'
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
